/* Yuvakart — testimonials layout adjustments.

   1) Star rating onto the same line as the reviewer name.
   2) On mobile, rebuild the slide as one vertical card:
        quote glyph -> quote text -> small square photo -> name
      The photo lives in a sibling panel (.ts__right), so CSS alone
      cannot place it between the quote and the name. This moves the
      .ts__zoom node into .ts__left just above .ts__who, and moves it
      back on desktop so the two-panel layout still works.
*/
(function(){

  var MOB = 749;

  function pairStars(stars){
    if (stars.getAttribute('data-ykts')) return;
    var who = stars.previousElementSibling;
    if (!who || !who.classList.contains('ts__who')) return;
    var inner = who.querySelector(':scope > div');
    if (!inner) return;
    var name = inner.querySelector('.ts__name');
    if (!name) return;

    var row = document.createElement('div');
    row.className = 'ykts__row';
    inner.insertBefore(row, name);
    row.appendChild(name);
    row.appendChild(stars);
    stars.setAttribute('data-ykts', '1');
  }

  function movePhoto(){
    var mobile = window.innerWidth <= MOB;
    var slides = document.querySelectorAll('.ts__slide');

    for (var i = 0; i < slides.length; i++){
      var sl    = slides[i];
      var left  = sl.querySelector('.ts__left');
      var right = sl.querySelector('.ts__right');
      var zoom  = sl.querySelector('.ts__zoom');
      var who   = left ? left.querySelector('.ts__who') : null;
      if (!left || !right || !zoom || !who) continue;

      if (mobile){
        if (zoom.parentNode !== left){ left.insertBefore(zoom, who); }
        if (sl.className.indexOf('ykts-mob') === -1){ sl.className += ' ykts-mob'; }
      } else {
        if (zoom.parentNode !== right){ right.appendChild(zoom); }
        sl.className = sl.className.replace(/\s*ykts-mob/g, '');
      }
    }
  }

  function run(){
    var all = document.querySelectorAll('.ts__stars');
    for (var i = 0; i < all.length; i++) pairStars(all[i]);
    movePhoto();
  }

  var t = null;
  function onResize(){
    clearTimeout(t);
    t = setTimeout(movePhoto, 160);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }

  setTimeout(run, 300);
  setTimeout(run, 1000);
  window.addEventListener('load', run);
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', function(){ setTimeout(movePhoto, 250); });

  try {
    new MutationObserver(function(){ run(); })
      .observe(document.body, { childList:true, subtree:true });
  } catch(e){}
})();